export const GoogleMapApiConfig = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyBcb9PIKQGszpWNji0pL--LUoO0wo4MgZs';